/** 사업자번호 포맷: 1234567890 → 123-45-67890 */
export const formatBusinessNumber = (value: string) => {
  const numeric = value.replace(/[^0-9]/g, '');
  if (numeric.length <= 3) return numeric;
  if (numeric.length <= 5) return `${numeric.slice(0, 3)}-${numeric.slice(3)}`;
  return `${numeric.slice(0, 3)}-${numeric.slice(3, 5)}-${numeric.slice(5)}`;
};

export const formatTimemmss = (time: number) => {
  const minutes = Math.floor(time / 60);
  const remainingSeconds = time % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
